import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { getAction } from '@/api/manage';
moment.locale('zh-cn');
export default {
  data: function data() {
    return {
      advanced: false,
      dataSource: [],
      pagination: {
        defaultPageSize: 10,
        defaultCurrent: 1,
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: function showTotal(total, range) {
          return "\u663E\u793A ".concat(range[0], " ~ ").concat(range[1], " \u6761\u8BB0\u5F55\uFF0C\u5171 ").concat(total, " \u6761\u8BB0\u5F55");
        }
      },
      loading: true,
      tableLoading: true
    };
  },
  computed: {
    columns: function columns() {
      return [{
        title: '请求时间',
        dataIndex: 'timestamp',
        customRender: function customRender(text) {
          return moment(text).format('YYYY-MM-DD HH:mm:ss');
        }
      }, {
        title: '请求方法',
        dataIndex: 'request.method',
        scopedSlots: {
          customRender: 'requestMethod'
        },
        filters: [{
          text: 'GET',
          value: 'GET'
        }, {
          text: 'POST',
          value: 'POST'
        }, {
          text: 'PUT',
          value: 'PUT'
        }, {
          text: 'DELETE',
          value: 'DELETE'
        }],
        filterMultiple: true,
        onFilter: function onFilter(value, record) {
          return record.request.method.includes(value);
        }
      }, {
        title: '请求URL',
        dataIndex: 'request.uri',
        customRender: function customRender(text) {
          return text.split('?')[0];
        }
      }, {
        title: '响应状态',
        dataIndex: 'response.status',
        scopedSlots: {
          customRender: 'responseStatus'
        }
      }, {
        title: '请求耗时',
        dataIndex: 'timeTaken',
        scopedSlots: {
          customRender: 'timeTaken'
        }
      }];
    }
  },
  created: function created() {
    this.fetch();
  },
  methods: {
    handleClickUpdate: function handleClickUpdate() {
      this.fetch();
    },
    handleTableChange: function handleTableChange() {
      this.fetch();
    },
    fetch: function fetch() {
      var _this = this;

      this.tableLoading = true;
      getAction('actuator/httptrace').then(function (data) {
        var filterData = [];

        var _iterator = _createForOfIteratorHelper(data.traces),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var d = _step.value;

            if (d.request.method !== 'OPTIONS' && d.request.uri.indexOf('httptrace') === -1) {
              filterData.push(d);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        _this.dataSource = filterData;
      }).catch(function (e) {
        console.error(e);

        _this.$message_custom('获取HTTP信息失败', 'error');
      }).finally(function () {
        _this.loading = false;
        _this.tableLoading = false;
      });
    }
  }
};